module.exports = __webpack_public_path__ + "static/gg-brand-417887e2e4059b10aba68b85e3242cdf.svg";